var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"py-16 py-md-15 my-md-10",attrs:{"id":"physique"}},[_c('v-container',[_c('v-row',{staticClass:"text-center",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10"}},[_c('h2',{class:[
            'font-weight-bold mb-8',
            _vm.$vuetify.breakpoint.mdAndUp ? 'text-h2' : 'text-h4',
          ]},[_vm._v(" "+_vm._s(_vm.$t("section_5_physique_title"))+" ")]),_c('p',{class:[
            _vm.$vuetify.breakpoint.mdAndUp ? 'text-h5' : 'text-h6',
            'font-weight-light text-left',
          ]},[_vm._v(" "+_vm._s(_vm.$t("section_5_physique_text"))+" ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }